import type { Job } from "../types/job";

const FAVICON_SZ = 128;

/**
 * Reliable small logo for map + list. Uses Google’s favicon endpoint (no API key).
 * `iconDomain` is a real site — demo jobs use fictional company names but real favicons.
 */
export function getJobLogoUrl(job: Job): string | null {
  const d = job.iconDomain?.trim();
  if (d) {
    return `https://www.google.com/s2/favicons?sz=${FAVICON_SZ}&domain=${encodeURIComponent(d)}`;
  }

  if (job.logo?.includes("logo.clearbit.com/")) {
    const host = job.logo.split("logo.clearbit.com/")[1]?.split(/[?#]/)[0];
    if (host) {
      return `https://www.google.com/s2/favicons?sz=${FAVICON_SZ}&domain=${encodeURIComponent(host)}`;
    }
  }

  if (job.logo?.startsWith("http")) {
    return job.logo;
  }

  return null;
}
